import { Container } from "reactstrap"
import Card from "./Card/Card"
import styles from './Creation.module.scss'

const Creation = () => {

  const data = [
    { title: 'Sponsored Products', image: 'https://placehold.co/600x400', desc: 'Details about this', link: '/advertisement/creation/sponsored-products' },
    { title: 'Sponsored Brands', image: 'https://placehold.co/600x400', desc: 'Details about this', link: '/advertisement/creation/sponsored-brands' },
    { title: 'Sponsored Display', image: 'https://placehold.co/600x400', desc: 'Details about this', link: '/advertisement/creation/sponsored-display' },
    { title: 'Banner Ads', image: 'https://placehold.co/600x400', desc: 'Details about this', link: '/advertisement/creation/sponsored-banner-ads' },
    { title: 'Sponsored Video Ads', image: 'https://placehold.co/600x400', desc: 'Details about this', link: '/advertisement/creation/sponsored-video-ad' },
    { title: 'Sponsored Blogs', image: 'https://placehold.co/600x400', desc: 'Details about this', link: '/advertisement/creation/sponsored-blogs' },
  ]

  return (
    <div style={{ background: "#f2f2f2", minHeight: "100dvh", paddingBlock: "1rem" }}>
      <Container fluid>
        <h4 className="fw-semibold mb-3">Advertisement Campaign Creation</h4>

        <div className={styles['wrapper']}>
          {data.map(item => <Card title={item.title} image={item.image} desc={item.desc} link={item.link} />)}
        </div>

      </Container>
    </div>
  )
}

export default Creation